import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import {useSelector} from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import './favourite-movies.scss';


function FavMovies({favMovie, setCounter}){
    const movies = useSelector(state => state.movies);
    const user= useSelector(state => state.user)

    function removeMovie(movieId){
        let token = localStorage.getItem('token');
		const url= `https://movieapi-production-2da7.up.railway.app/users/${user}/movies/${movieId}`;
        axios.delete(url,{
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(response=>{
            console.log(response.data);
            // window.open(`/users/${user}`, '_self')
          setCounter(prevCount => prevCount + 1);
          }
            )
          .catch(err => console.log(err))

    }


    return(
        <>
                {movies.map(movie=>{
                    if(favMovie.includes(movie._id)) return <Card className="fav-movie-card" key={movie._id}>
                            <Card.Img className="movie-poster" src={movie.ImagePath} alt='movie-portrait' />
                            <Card.Body>
                                <Card.Title>{movie.Title}</Card.Title>
                                <Button variant="success" onClick={()=>removeMovie(movie._id)} >Delete</Button>
                            </Card.Body>
                        </Card>
                })}
        </>
    )
}

FavMovies.propTypes={
    favMovie: PropTypes.string.isRequired
  }

export default FavMovies